import { CloseIcon } from 'assets/icons/CloseIcon'
import { CancelBtn } from 'components/Button/CancelBtn'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { ISelectValue } from 'constants/globalTypes'
import { addBreakPolicy } from 'features/breaks/breaksSlice'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AppDispatch } from 'store'
import { Button, Flex, H1WithBack, ItemsGrid, PageFooter, PageWrapper, ThinSeparator } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const AddBreakPolicy = () => {
    const [state, setState] = useState<IBreakPolicyState>({
        breakTemplate: null,
        scopeType: { label: 'Company', value: 1 },
        maxOnBreak: null,
        minActive: null,
        minGapBetweenBreaksInMinutes: null,
        validFromDate: null,
        validToDate: null,
        constraints: []
    })

    const [breakTemplateBreakOptions, setOptionsForBreakTemplateBreakOptions] = useState<ISelectValue[]>([])
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()

    const handleSelect = (v: ISelectValue, name: string) => {
        if (name == 'breakTemplate') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //  @ts-ignore
            setOptionsForBreakTemplateBreakOptions(v.breaks.map(b => ({ value: b.id, label: b.durationMinutes + ' min.' })))
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //  @ts-ignore
            delete v.breakas
        }

        setState(prev => ({ ...prev, [name]: v }))
    }

    const handleDate = (date: Date, name: string) => {
        setState(prev => ({ ...prev, [name]: date }))
    }


    const handleSubmit = async () => {
        const resp = await dispatch(addBreakPolicy(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, valueAsNumber } = e.target
        setState(prev => ({ ...prev, [name]: valueAsNumber }))
    }

    const parseMaybeNumber = (raw: string): number | null => {
        if (raw === '') return null
        const num = Number(raw)
        return Number.isNaN(num) ? null : num
    }

    const addConstraint = () => {
        if (!breakTemplateBreakOptions.length) {
            toast.warn('Break template must be selected and it must contain breaks')
            return
        }
        setState(prev => ({
            ...prev,
            constraints: [
                ...prev.constraints,
                {
                    id: new Date().getTime(),
                    breakTemplateBreak: null,
                    index: prev.constraints.length + 1,
                    anchorType: null,
                    minOffsetMinutes: null,
                    maxOffsetMinutes: null,
                    placementStrategyType: null,
                    durationOverrideMinutes: null,
                    enforcementType: null,
                }
            ]
        }))
    }

    const updateConstraint = (constraintIndex: number, name: string, value: any) => {
        setState(prev => ({
            ...prev,
            constraints: prev.constraints
                .map((c, i) => (i === constraintIndex ? { ...c, [name]: value } : c))
                .map((c, i) => ({ ...c, index: i + 1 })),
        }))
    }

    const deleteConstraint = (constraintIndex: number) => {
        setState(prev => ({
            ...prev,
            constraints: prev.constraints
                .filter((_, i) => i !== constraintIndex)
                .map((c, i) => ({ ...c, index: i + 1 })),
        }))
    }

    console.log(state)

    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Break Policy' />
            <ItemsGrid mt='16px' columns={4}>
                <HonestSelectAsyncInput required labelText='Break Template' nomarg defaultValue={state.breakTemplate?.label} onChange={handleSelect} name='breakTemplate' link='break/template' parserFunction={data => data.data.map(p => ({ value: p.id, breaks: p.breaks, label: p.name }))} />
                <HonestSelectInput required options={scopeTypeOptions} nomarg labelText='Scope type' defaultValue={state.scopeType?.value} onChange={handleSelect} name='scopeType' />
                <Input value={state.maxOnBreak} required nomarg labelText='Max on break' name='maxOnBreak' type='number' placeholder='Enter here...' onChange={handleChange} />
                <Input value={state.minActive} required nomarg labelText='Minimum active' name='minActive' type='number' placeholder='Enter here...' onChange={handleChange} />
                <Input value={state.minGapBetweenBreaksInMinutes} required nomarg labelText='Minumum gap between breaks (min)' name='minGapBetweenBreaksInMinutes' type='number' placeholder='Enter here...' onChange={handleChange} />
                <CalendarInput maxDate={state.validToDate} minDate={new Date()} nomarg name='validFromDate' labelText='Valid From' onChange={handleDate} defaultValue={state.validFromDate} />
                <CalendarInput minDate={state.validFromDate} nomarg labelText='Valid To' name='validToDate' onChange={handleDate} defaultValue={state.validToDate} />
            </ItemsGrid>
            <ThinSeparator />
            <Flex column gap='1rem' mt='16' width='100%'>
                <Flex between center mb='16' >
                    <Flex column style={{ justifyContent: 'center' }}>
                        <TitleText weight='bold' >Constraints</TitleText>
                    </Flex>
                    <Button orange onClick={addConstraint} disabled={!breakTemplateBreakOptions.length}>
                        Add Constraint
                    </Button>
                </Flex>

                {state.constraints.map((constraint, idx) => {
                    return (
                        <Flex
                            key={idx}
                            gap='1rem'
                            center
                        >
                            <HonestSelectInput
                                required
                                nomarg
                                labelText='Break'
                                options={breakTemplateBreakOptions}
                                defaultValue={constraint.breakTemplateBreak?.value}
                                onChange={(v) => updateConstraint(idx, 'breakTemplateBreak', v)}
                                name='breakTemplateBreak'
                                disabled={!breakTemplateBreakOptions.length}
                            />

                            <HonestSelectInput
                                required
                                nomarg
                                labelText='Anchor'
                                options={anchorTypeOptions}
                                defaultValue={constraint.anchorType?.value}
                                onChange={(v: ISelectValue) => updateConstraint(idx, 'anchorType', v)}
                                name='anchorType'
                            />

                            <Input
                                allowZero
                                required
                                nomarg
                                labelText='Min offset (min)'
                                type='number'
                                value={constraint.minOffsetMinutes}
                                placeholder='Enter here...'
                                onChange={(e) => updateConstraint(idx, 'minOffsetMinutes', parseMaybeNumber(e.target.value))}
                            />

                            <Input
                                required
                                allowZero
                                nomarg
                                labelText='Max offset (min)'
                                type='number'
                                value={constraint.maxOffsetMinutes}
                                placeholder='Enter here...'
                                onChange={(e) => updateConstraint(idx, 'maxOffsetMinutes', parseMaybeNumber(e.target.value))}
                            />

                            <HonestSelectInput
                                required
                                nomarg
                                labelText='Placement'
                                options={placementStraregyOptions}
                                defaultValue={constraint.placementStrategyType?.value}
                                onChange={(v) => updateConstraint(idx, 'placementStrategyType', v)}
                                name='placementStrategyType'
                            />

                            <Input
                                allowZero
                                required
                                nomarg
                                labelText='Duration override (min)'
                                type='number'
                                value={constraint.durationOverrideMinutes}
                                placeholder='Enter here...'
                                onChange={(e) => updateConstraint(idx, 'durationOverrideMinutes', parseMaybeNumber(e.target.value))}
                            />

                            <HonestSelectInput
                                required
                                nomarg
                                labelText='Enforcement'
                                options={enforcementTypeOptions}
                                defaultValue={constraint.enforcementType?.value}
                                onChange={(v) => updateConstraint(idx, 'enforcementType', (v as ISelectValue))}
                                name='enforcementType'
                            />
                            <div style={{ width: 50 }} >
                                <CloseIcon onClick={() => deleteConstraint(idx)} />
                            </div>
                        </Flex>
                    )
                })}
            </Flex>
        </ PageWrapper>
        <PageFooter>
            <Flex width='100%' end='true'>
                <CancelBtn />
                <Button ml='15' height='40' orange onClick={handleSubmit}>
                    Save
                </Button>
            </Flex>
        </PageFooter>

    </>
}

export const scopeTypeOptions = [{ value: 1, label: 'Company' }]

export const anchorTypeOptions = [{ value: 1, label: 'Shift Start' }, { value: 2, label: 'Shift End' }]

export const placementStraregyOptions = [{ value: 1, label: 'Earliest' }, { value: 2, label: 'Latest' }, { value: 3, label: 'Midpoint' }]

export const enforcementTypeOptions = [{ value: 1, label: 'Hard' }, { value: 2, label: 'Soft' }]


export interface IBreakPolicyState {
    id?: string
    breakTemplate: ISelectValue
    scopeType: ISelectValue
    maxOnBreak: number
    minActive: number
    minGapBetweenBreaksInMinutes: number
    validFromDate: Date
    validToDate: Date
    constraints: {
        id?: number
        breakTemplateBreak: ISelectValue
        index: number
        anchorType: ISelectValue
        minOffsetMinutes: number | null
        maxOffsetMinutes: number | null
        placementStrategyType: ISelectValue
        durationOverrideMinutes: number | null
        enforcementType: ISelectValue
    }[]
}


